import { isUndefined } from 'lodash-es';

export const shouldUseFilter = (
  value: 'data-min' | 'data-max' | number | undefined,
): value is number =>
  !isUndefined(value) && value !== 'data-min' && value !== 'data-max';
